import axios from "axios";
import config from "src/config";

const URLVALIDATETRANSACTION = config.url.URLVALIDATETRANSACTION;

export const TransactionsAPI = {
  async validate(contextData, transactionsData) {
    try {
      const headers = {
            'Content-Type': 'application/json',
            'customer': contextData.clientId,
            'session-id': contextData.sessionId,
            'sso': contextData.cookie
          }
      const response = await axios.post(URLVALIDATETRANSACTION, transactionsData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};